import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import Home from '../components/Home';
import Back1 from '../assets/images/back-home-1.webp';
import MarketPlaceSummary from '../components/MarketPlaceSummary';
import TransformationStartsNow from '../components/TransformationStartsNow';
import Statistics from '../components/Statistics';
import OurApi from '../components/OurApi';
import OurClients from '../components/OurClients';
import SEO from '../components/SEO';
import SemiTransparentBackground from '../components/SemiTransparentBackground';

export { Nosotros } from './Nosotros';
export { Servicios } from './Servicios';
export { AnalisisCredito } from './AnalisisCredito';
export { Pld } from './Pld';
export { Dispersion } from './Dispersion';
export { Cobranza } from './Cobranza';
export { CardEmision } from './CardEmision';
export { LockPhone } from './LockPhone';
export { PayServices } from './PayServices';
export { CampaignNoti } from './CampaignNoti';
export { Scoring } from './Scoring';
export { Beneficios } from './Beneficios';
export { CoreBancario } from './CoreBancario';

export const Index = () => {
  const { t, i18n } = useTranslation();
  return (
    <Layout backgroundimage={Back1} actionDemo={true}>
      <SemiTransparentBackground />
      <SEO
        title={t("Core Bancario")}
        metaCia={t('Soluciones Digitales para Entidades Financieras')}
        description={t('Descubre nuestra plataforma de core bancario digital diseñada para optimizar los procesos, automatizar operaciones y digitalizar productos financieros.')}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        bolImage={false}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en' : ''}`}
      />
      <Home/>
      <MarketPlaceSummary/>
      <TransformationStartsNow/>
      <Statistics/>
      <OurApi/>
      <OurClients/>
    </Layout>
  )
}
